// extracted by mini-css-extract-plugin
export default {"vinyl":"Vinyl_vinyl__WnscM","vinyl_wrap":"Vinyl_vinyl_wrap__E4y8c"};